import Link from "components/Link";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { titleize } from "helpers/string";

interface MeetingLinksFieldsProps {
  videoConferenceUrl?: string | null;
  videoConferenceProvider?: string | null;
  externalUrl?: string | null;
  videoConferenceLabel?: string;
  externalUrlLabel?: string;
}

export default function MeetingLinksFields({
  videoConferenceUrl,
  videoConferenceProvider,
  externalUrl,
  videoConferenceLabel,
  externalUrlLabel = "External URL",
}: MeetingLinksFieldsProps) {
  return (
    <>
      {videoConferenceUrl && (
        <HorizontalGreyBlackField
          label={videoConferenceLabel || (videoConferenceProvider ? titleize(videoConferenceProvider) : "Video Conferencing")}
          labelProps={{ marginBottom: 0 }}
          labelContainerProps={longAttributeStyles.labelContainerProps}
        >
          <Link to={videoConferenceUrl} text="Join Meeting" fontSize="sm" />
        </HorizontalGreyBlackField>
      )}
      {externalUrl && (
        <HorizontalGreyBlackField
          label={externalUrlLabel}
          labelProps={{ marginBottom: 0 }}
          labelContainerProps={longAttributeStyles.labelContainerProps}
        >
          <Link to={externalUrl} text="View in Google Calendar" fontSize="sm" />
        </HorizontalGreyBlackField>
      )}
    </>
  );
}
